import { BID, RESUME_DRAFT, REMOVE_BID } from "../actions/constants";

const initialState = {
  bid: {},
  resume_draft: {},
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case BID:
      return {
        ...state,
        bid: action.payload,
      };
    case RESUME_DRAFT:
      return {
        ...state,
        resume_draft: action.payload,
      };
    case REMOVE_BID:
      return {
        ...state,
        bid: {},
        resume_draft: {},
      };
    default:
      return state;
  }
}
